import { Component, inject } from '@angular/core';
import { TractorAttachmentService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  TractorAttachmentCreateDto,
  TractorAttachmentDto,
  TractorAttachmentExcelDownloadDto,
  TractorAttachmentUpdateDto,
} from '../proxy/general/dtos/tractor-attachment';
import { TRACTORATTACHMENT_CONFIG, TRACTORATTACHMENT_FIELDS } from './tractor-attachment.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-tractor-attachment',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, TractorAttachmentService, ConfirmationService],
  templateUrl: './tractor-attachment.html',
  styleUrl: './tractor-attachment.scss',
})
export class TractorAttachment extends BaseCrudComponent<
  TractorAttachmentDto,
  TractorAttachmentCreateDto,
  TractorAttachmentUpdateDto,
  TractorAttachmentExcelDownloadDto
> {
  service = inject(TractorAttachmentService);
  config = TRACTORATTACHMENT_CONFIG;
  fields = TRACTORATTACHMENT_FIELDS;

  protected prepareUpdateDto(data: any, selected: TractorAttachmentDto): TractorAttachmentUpdateDto {
    return {
      name: data.name,
      hasTag: data.hasTag,
      brandId: data.brandId,
      modelId: data.modelId,
      tractorAttachmentTypeId: data.tractorAttachmentTypeId,
      vendorId: data.vendorId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'TractorAttachment';
  }
}
